import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/themes.css'

// Aplicar tema guardado al cargar (sistema Zustand)
const applyStoredTheme = () => {
  try {
    const storedTheme = localStorage.getItem('agentlink-theme')
    if (storedTheme) {
      const parsed = JSON.parse(storedTheme)
      const theme = parsed.state?.theme || 'light'
      document.documentElement.setAttribute('data-theme', theme)
    } else {
      document.documentElement.setAttribute('data-theme', 'light')
    }
  } catch {
    document.documentElement.setAttribute('data-theme', 'light')
  }
}

// Aplicar preferencias guardadas al cargar (zoom y otras preferencias)
const applyStoredPreferences = () => {
  try {
    const savedPreferences = localStorage.getItem('agentlink_preferences')
    if (savedPreferences) {
      const prefs = JSON.parse(savedPreferences)
      
      // Aplicar zoom level
      if (prefs.zoomLevel) {
        document.documentElement.setAttribute('data-zoom-level', prefs.zoomLevel)
        const scaleMap: Record<string, number> = {
          small: 0.85,
          medium: 0.925,
          large: 1.0
        }
        const scale = scaleMap[prefs.zoomLevel] || 1.0
        document.body.style.transform = `scale(${scale})`
        document.body.style.transformOrigin = 'top left'
        document.body.style.width = `${100 / scale}%`
        document.body.style.height = `${100 / scale}%`
      }
      
      // Aplicar font size
      if (prefs.fontSize) {
        document.documentElement.setAttribute('data-font-size', prefs.fontSize)
      }
      
      // Aplicar idioma
      if (prefs.language) {
        document.documentElement.setAttribute('lang', prefs.language)
      }
    }
  } catch (error) {
    console.error('Error applying stored preferences:', error)
  }
}

// Aplicar tema y preferencias antes de renderizar
applyStoredTheme()
applyStoredPreferences()

// Debug marker to confirm latest bundle is loaded
if (import.meta.env.DEV) console.log('[BUILD_MARK] agentlink-frontend 2026-01-07T14:50Z-CLEAN-CONSOLE')

try {
  if (import.meta.env.DEV) console.log('[DEBUG] Attempting to mount React...')
  const rootElement = document.getElementById('root')
  if (!rootElement) {
    throw new Error('Root element not found')
  }
  if (import.meta.env.DEV) console.log('[DEBUG] Root element found, creating React root...')
  const root = ReactDOM.createRoot(rootElement)
  if (import.meta.env.DEV) console.log('[DEBUG] React root created, rendering App...')
  root.render(
    <App />
  )
  if (import.meta.env.DEV) console.log('[DEBUG] React render called successfully')
} catch (error) {
  console.error('[DEBUG] Failed to mount React:', error)
  document.getElementById('root')!.innerHTML = '<div style="padding:20px;color:red;font-family:monospace;">Error mounting React: ' + error + '</div>'
}

